import React, { useState } from 'react';
import {Modal} from "../react-native-components-in-react/react-native-components-in-react";
import ZoomImage from "./ZoomImage";

const ImageModal = (props) => {
    return (
        <Modal
            visible={props.visible} onRequestClose={props.onRequestClose}
            style={{ backgroundColor: 'transparent' }}
            bodyStyle={{ padding: 0, backgroundColor: 'transparent' }}
        >
            <ZoomImage
                image={props.image}
            />
        </Modal>
    );
}

export default ImageModal;
